// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_D4v2iE","section__separator":"ob_Zljo19","section__container":"ob_LelmoU","section":"ob_Tx60a9"};